import React from 'react';
import ReactDOM from 'react-dom/client';
import Router from "./routes/routes";
import 'popper.js';
import 'jquery';
import 'bootstrap/dist/css/bootstrap.min.css';
import './common/styles/css/index.css';
import './common/styles/css/custom-kiwox.css';
import './styles/css/sello-qr.css'
import { CssBaseline } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';

import CookieNoticeContainer from './common/components/container/cookieNoticeContainer'

const theme = createTheme();
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider theme={theme}>
    <React.StrictMode>
      <CssBaseline />
      <Router />
      <CookieNoticeContainer />
    </React.StrictMode>
  </ThemeProvider>,
);